import React from 'react';
import Icon from '../../../components/AppIcon';

const FutureVision = () => {
  const initiatives = [
    {
      icon: 'Battery',
      title: 'Expansão do Sistema',
      description: 'Aumentar a capacidade de geração e armazenamento de energia.',
      timeline: '2025'
    },
    {
      icon: 'Car',
      title: 'Estação de Carregamento',
      description: 'Instalação de pontos de carregamento para veículos elétricos.',
      timeline: '2025'
    },
    {
      icon: 'Recycle',
      title: 'Economia Circular',
      description: 'Implementação de programas de economia circular e upcycling.',
      timeline: '2026'
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4 px-4 py-2 rounded-full bg-accent/10 text-accent border border-accent/20">
            <Icon name="Rocket" size={20} className="mr-2" />
            <span className="text-sm font-medium">Visão Futuro</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
            Construindo o Amanhã
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Nossa jornada de sustentabilidade está apenas começando. 
            Temos grandes planos para tornar o Estação Marina ainda mais verde e inovador.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {initiatives.map((initiative, index) => (
            <div
              key={index}
              className="bg-card rounded-2xl p-6 border border-border shadow-warm hover:shadow-warm-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center">
                    <Icon name={initiative.icon} size={24} className="text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-heading font-semibold text-foreground">
                      {initiative.title}
                    </h3>
                    <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded-full">
                      {initiative.timeline}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {initiative.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer message */}
        <div className="text-center mt-16">
          <p className="text-lg text-muted-foreground mb-4">
            A sustentabilidade é uma jornada contínua, não um destino.
          </p>
          <div className="flex items-center justify-center gap-2 text-primary">
            <Icon name="Heart" size={20} />
            <span className="font-medium">Estação Marina - Comprometidos com o Futuro</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FutureVision;
